<div class="mat-headline-6">Reviews</div>
<div fxLayout="column" fxLayoutGap="20px">
  @for (review of displayedReviews; track review) {
    <ag-review [review]="review" [reviewLength]="reviewLength"></ag-review>
  }
  <div fxLayout="row" fxLayoutAlign="center start">
    @if (displayedReviews.length < reviews.length) {
      <button
        mat-button
        color="primary"
        class="ag-mat-button-primary"
        type="button"
        (click)="showMoreReviews()"
      >
        See More Reviews
      </button>
    }
  </div>
</div>
